import {Component, Vue} from 'vue-property-decorator'

@Component
class IsChatEnabled extends Vue {
    static chatButtonKey = 'chat';

    buttonOptions = {
        [IsChatEnabled.chatButtonKey]: {
            enabled: true
        }
    };

    get showChatButton() {
        if (!this.$store.getters['events/allowChatWithSpeakers'] && this.isSpeaker) {
            return false;
        }
        if (this.buttonOptions && this.buttonOptions[IsChatEnabled.chatButtonKey]) {
            return this.buttonOptions[IsChatEnabled.chatButtonKey].enabled;
        }
        return true;
    }

    get isSpeaker() {
        return false;
    }

    get showChatButtonToCurrentUser(): boolean {
        if (!this.showChatButton) {
            return false;
        }

        return this.$store.getters['events/isChatAllowed'];
    }

    get showPayButtonInsteadChat(): boolean {
        const payParams = this.$store.getters['events/selectedEventViewParam']('accessPayments', null);
        return !this.showChatButtonToCurrentUser && !this.isSpeaker && payParams !== null;
    }
}

export {IsChatEnabled}